import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';

class FsBadgeComponent {
    constructor() {
        this.text = '';
        this.shape = 'circle';
        this.styles = {};
        this.iconStyle = {};
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        this.type = this.image ? 'image' : 'text';
        this.styles = {};
        this.iconStyle = {};
        if (this.backgroundSize) {
            this.styles['background-size'] = this.backgroundSize;
        }
        if (this.iconSize) {
            this.iconStyle.transform = 'scale(' + this.iconSize + ')';
        }
        if (this.iconColor) {
            this.iconStyle.color = this.iconColor;
        }
        if (this.color) {
            this.styles['background-color'] = this.color;
        }
        if (this.size) {
            this.styles.width = this.size + 'px';
            this.styles['min-width'] = this.size + 'px';
            if (this.shape === 'circle') {
                this.styles.height = this.size + 'px';
                this.styles['line-height'] = this.size + 'px';
            }
            if (this.text) {
                this.styles['font-size'] = (this.size / 2.5) + 'px';
            }
        }
        if (this.image) {
            this.styles['background-image'] = 'url(' + this.image + ')';
        }
    }
}
FsBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsBadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsBadgeComponent, selector: "fs-badge", inputs: { color: "color", text: "text", tooltip: "tooltip", size: "size", shape: "shape", image: "image", icon: "icon", iconSize: "iconSize", iconColor: "iconColor", backgroundSize: "backgroundSize" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"fs-badge\"\n    [ngClass]=\"{ 'fs-badge-circle': shape === 'circle', 'fs-badge-image': type === 'image', 'fs-badge-text': type === 'text' }\"\n    [ngStyle]=\"styles\"\n    [matTooltip]=\"tooltip\">\n  <mat-icon *ngIf=\"!image && icon\" [ngStyle]=\"iconStyle\">{{ icon }}</mat-icon>\n  <ng-container *ngIf=\"!image && text\">{{ text }}</ng-container>\n</div>\n", styles: [".fs-badge{display:inline-flex;height:20px;align-items:center;justify-content:center;border-radius:3px;vertical-align:bottom}.fs-badge.fs-badge-text{text-transform:uppercase;min-width:45px;color:#fff;font-size:14px}.fs-badge.fs-badge-circle{min-width:32px;height:32px;width:32px;padding:0;border-radius:50%}.fs-badge.fs-badge-image{background-repeat:no-repeat;background-size:cover;background-position:50% 50%}\n"], components: [{ type: i1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsBadgeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-badge',
                    templateUrl: './badge.component.html',
                    styleUrls: ['./badge.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { color: [{
                type: Input
            }], text: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], size: [{
                type: Input
            }], shape: [{
                type: Input
            }], image: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], iconColor: [{
                type: Input
            }], backgroundSize: [{
                type: Input
            }] } });

class FsBadgeModule {
}
FsBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsBadgeModule, declarations: [FsBadgeComponent], imports: [CommonModule,
        MatIconModule,
        MatTooltipModule], exports: [FsBadgeComponent] });
FsBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsBadgeModule, providers: [], imports: [[
            CommonModule,
            MatIconModule,
            MatTooltipModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatTooltipModule
                    ],
                    exports: [
                        FsBadgeComponent,
                    ],
                    entryComponents: [],
                    declarations: [
                        FsBadgeComponent,
                    ],
                    providers: [],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsBadgeComponent, FsBadgeModule };
